import React from "react";

const AboutPage: React.FC = () => {
    return (
        <div className="pt-20 fles flex-col px-3 md:px-40 gap-[30px]">
            <h3 className="text-[18px] md:text-[29px] font-bold text-center">About Us</h3>
            <p className="text-[16px] md:text-[20px] text-justify">Our team of legal experts, technologists, and customer service professionals is 
                dedicated to providing a user-friendly and supportive experience for all of our users. 
                We are committed to upholding the highest standards of ethical conduct and data privacy.
            </p>

            <p className="text-[16px] md:text-[20px] text-justify">We believe that everyone deserves equal access to legal services, regardless of their geographic location or financial means. 
                By leveraging cutting-edge technology, we are able to create a virtual courtroom that eliminates the barriers of time, distance, and cost.
            </p>
        </div>
    )
}
export default AboutPage